<template>
  <v-autocomplete
    v-model="departmentValue"
    @input="handleInput"
    :clearable="clearable"
    :dense="dense"
    :items="departments"
    :item-value="getItemValue"
    :loading="isLoading"
    :multiple="multiple"
    :outlined="outlined"
    :return-object="returnObject"
    :rules="rules"
    :search-input="search"
    item-text="name"
    :label="$t('commons.department')"
  ></v-autocomplete>
</template>

<script>
import DepartmentService from "@/services/DepartmentService"

export default {
  name: "DepartmentInput",
  props: {
    rules: {
      type: Array,
      default: () => []
    },
    outlined: {
      type: Boolean,
      default: true
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    value: {
      default: null
    }
  },
  computed: {
    company() {
      return this.$store.state.app.company
    }
  },
  data() {
    return {
      search: "",
      isLoading: false,
      departmentValue: null,
      departments: []
    }
  },
  created() {
    this.fetchData()
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.departmentValue = newValue
        }
      }
    }
  },
  methods: {
    fetchData() {
      this.isLoading = true
      this.getData()
        .then(results => {
          this.departments = results
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getData() {
      return DepartmentService.getDepartment(this.company.pk)
    },
    handleInput(newValue) {
      this.$emit("input", newValue)
    },
    getItemValue(item) {
      return item.id
    }
  }
}
</script>
